<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>DREAMS and VISIONS</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="tx"><br/><br/><br/><br/></p>
<p class="txc7" id="p0010-02-1"><span><i>I revealed myself <br/>to those who did not ask for me; <br/>I was found <br/>by those who did not seek me.</i><br/>                                    —I<span class="smallcaps">SAIAH 65:1 </span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?1c5b0f87